import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  children: ReactNode;
  actions?: ReactNode;
}

export const Section = ({ title, description, children, actions }: Props) => (
  <section className="card overflow-hidden">
    <header className="px-[22px] pt-[18px] pb-4 flex items-start justify-between gap-4">
      <div>
        <h2 className="text-base font-semibold text-ink tracking-tight m-0">{title}</h2>
        {description && (
          <p className="mt-1 text-[12.5px] text-ink-muted m-0">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
    <div className="px-[22px] pb-[22px] space-y-4">{children}</div>
  </section>
);

export const Field = ({
  label,
  hint,
  children,
  error,
}: {
  label: string;
  hint?: ReactNode;
  children: ReactNode;
  error?: string | null;
}) => (
  <div>
    <div className="flex justify-between items-baseline mb-1.5">
      <label className="text-[11.5px] font-medium text-ink-soft">{label}</label>
      {hint && !error && (
        <span className="text-[11px] text-ink-subtle">
          {typeof hint === 'string' ? hint : hint}
        </span>
      )}
    </div>
    {children}
    {error && <div className="text-[11.5px] text-rose-700 mt-1">{error}</div>}
  </div>
);
